import React, { Component } from 'react';
import { Box, type Theme } from '@mui/material';

import classnames from 'classnames';
import {blue,pink,green} from '@mui/material/colors';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import ResourceView from './ResourceView';
import { PDFIcon, CSVIcon, JSONIcon, ZIPIcon} from '../../components/icons';
import Download from '../../ajax/download';
import { extendedstyles } from '../appstyles';

const s:any ={
  root: {
    width: '100%',
  },
  heading: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
  }),
  secondaryHeading: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  }),
  secondaryHeading2: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
    color: blue[600], //theme.palette.text.secondary,
  }),
  topheading: {
    fontWeight:'bold',
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  details: {
    alignItems: 'center',
  },
  column: {
    flexBasis: '33.3%',
  },
  gridtitle: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
    color: pink['500'],
    fontWeight:'bold',
  }),
  gridroot: {
    width: '100%',
  },
  gridrow: {
    display: 'flex',
    width: 600,
    border: '1px solid #eeeeee',
    textAlign: 'left',
  },
  gridcolumnauto: {
    flexBasis: 'fill',
    textAlign: 'left',
    borderRight: '1px solid #eeeeee',
  },
  gridcolumn30: {
    flexBasis: 'auto',
    width: '200px',
    textAlign: 'left',
    borderRight: '1px solid #eeeeee',
  },
  gridcontent: {
    textAlign: 'left',
    paddingLeft: '20px',
  },
  dcolumn: {
    width: '100%',
    display: 'flex',
    flexBasis: '50%',
  },
  helper: {
    //borderLeft: `2px solid ${theme.palette.text.hint}`,
    //borderLeft: `2px solid ${rgba(0, 0, 0, 0.38)}`,
    borderLeft: `2px solid #000000aa`,
    p: '1, 2',
  },
  link: {
    color: 'primary.main',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  iconsroot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  customicon: {
    m: 2,
    color: pink["500"]
  },
  iconHover: {
    m: 2,
    '&:hover': {
      color: green[200],
    },
  },
  
};


class ResultView extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      views:[],
      count:0,
      datasets: null,
      dataset: null
    };
  }

  handleClick = (name:any) => () => {
    //var btn = event.target;
    var {data,record,user} = this.props;
    var d = new Download();
    d.downloadFile(name,data,record);
  } 

  render() {
    const {result,classes } = this.props;
    var sdoc = result.sdoc;
    var vers = Object.keys(sdoc);
    const vts:any = {'POI':'ID Verification','POA':'Address Verification'};
    return (
      <Box sx={{...s.root}}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{...s.column}}>
              <Typography className={classnames(classes.heading,classes.topheading)}>
                Status
              </Typography>
            </Box>
            <Box sx={{...s.column}}>
              <Typography className={classnames(classes.secondaryHeading,classes.topheading)}>
                {result.jsonsumm.status}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box>
            {result.info.map( (infoitem:any,ii:number) => (
              <Box key={`info_${ii}`} sx={{...s.gridrow}}>
                <Box sx={{...s.gridcolumn30}}>
                  <Typography>
                    {infoitem.title}
                  </Typography>
                </Box>
                <Box sx={{...s.gridcolumnauto}}>
                  <Typography sx={{...s.secondaryHeading2}}>
                    {infoitem.value}
                  </Typography>
                </Box>
              </Box>
            ))}
            </Box>
            <Box></Box>
          </AccordionDetails>
        </Accordion>
        {result.vers.map( (veritem:any,vei:number) => (
          <Box key={`ver_${vei}`}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{...s.column}}>
                  <Typography sx={{...s.heading}}>
                    {veritem.title}
                  </Typography>
                </Box>
                <Box sx={{...s.column}}>
                  <Typography sx={{...s.secondaryHeading}}>
                    {veritem.value}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{...s.details}}>
                <Box>
                  {(result.tile[veritem.field])?
                  <ResourceView name={result.name} tileData={result.tile[veritem.field]} />
                  :""}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Box>
        ))}
        {(result.errs.length>0)?
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography className={classnames(classes.heading,classes.topheading)}>
                Errors
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{...s.details}}>
                <Box>
                  {result.errs.map( (erritem:any,i:number) => (
                    <Box key={`err_${i}`} sx={{...s.gridrow}}>
                    {/* <Box key={erritem.field} sx={{...s.gridrow}}> */}
                      <Box sx={{...s.gridcolumn30}}>
                        <Typography sx={{...s.heading}}>
                          <Box component='span'>{erritem.title}</Box>
                        </Typography>
                      </Box>
                      <Box sx={{...s.gridcolumnauto}}>
                        <Typography sx={{...s.secondaryHeading2}}>
                          <Box component='span'>{erritem.error}</Box>
                        </Typography>
                      </Box>
                      <Divider />
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          // </Box>
        :""}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classnames(classes.heading,classes.topheading)}>
              Data
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            {/* <Box> */}
              {vers.map(n => {
                var docs = sdoc[n];
                var dockeys = Object.keys(docs);
                return dockeys.map( (vn,vi) => {
                  var docdata = docs[vn];
                  return (
                    <Box key={`doc_${vi}`}>
                      <Box sx={{...s.gridtitle}}>{vts[n]||n} - {vn}</Box> 
                      <Box>
                      {docdata.map( (dataitem:any,di:number) => {
                        return (
                          <Box key={`docdata_${di}`} sx={{...s.gridrow}}>
                          {/* <Box key={dataitem.field} sx={{...s.gridrow}}> */}
                            <Box sx={{...s.gridcolumn30}}>
                              <Typography sx={{...s.heading}}>
                                <Box component='span'>{dataitem.title}</Box>
                              </Typography>
                            </Box>
                            <Box sx={{...s.gridcolumnauto}}>
                              <Typography sx={{...s.secondaryHeading2}}>
                                <Box component='span'>{dataitem.value}</Box>
                              </Typography>
                            </Box>
                            <Divider />
                          </Box>
                        );
                      })} 
                      </Box>
                    </Box>
                  );  
                });
              })}
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classnames(classes.heading,classes.topheading)}>
              Validations
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box sx={{...s.gridroot}}>
            {result.vals.map( (valitem:any,vai:number) => {
              return (
                <Box key={`val_${vai}`} sx={{...s.gridrow}}>
                {/* <Box key={valitem.validation} sx={{...s.gridrow}}> */}
                  <Box sx={{...s.gridcolumn30}}>
                    <Typography sx={{...s.heading}}>
                      <Box component='span' sx={{...s.gridcontent}}>{valitem.title}</Box>
                    </Typography>
                  </Box>
                  <Box sx={{...s.gridcolumnauto}}>
                    <Typography sx={{...s.heading}}>
                      <Box component='span' sx={{...s.gridcontent}}>{valitem.validation}</Box>
                    </Typography>
                  </Box>
                  <Box sx={{...s.gridcolumn30}}>
                    <Typography sx={{...s.secondaryHeading2}}>
                      <Box component='span' sx={{...s.gridcontent}}>{valitem.result}</Box>
                    </Typography>
                  </Box>
                  <Divider />
                </Box>
              );
            })} 
            </Box>    
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classnames(classes.heading,classes.topheading)}>
              Downloads
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{...s.details}}>
            <Box>
              <Box sx={{...s.iconsroot}}>
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('pdf')}>
                    <PDFIcon titleAccess="PDF Download"/>
                  </Button>
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('csv')}>
                    <CSVIcon titleAccess="CSV Download"/>
                  </Button>
                  {/* <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('json')}>
                    <JSONIcon titleAccess="JSON Download" />
                  </Button> */}
                  <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('zip')}>
                    <ZIPIcon titleAccess="ZIP Download" />
                  </Button>
              </Box>
            </Box>
            <Box></Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  }
}

export default ResultView;